<template>
  <div class="select-binding">
    <multiselect
      class="select"
      type="text"
      track-by="id"
      v-model="selected"
      :loading="!list.loaded"
      :options="list.data"
      :label="label"
    />
    <vbutton
      v-if="selected"
      :label="$tr('vacancy.settings.talentq.project-untie')"
      :color="'grey'"
      @click="selected = null"/>
  </div>
</template>

<script>
  export default {
    name: "select-binding",
    props: {
      list: {
        type: Object,
        required: true,
      },
      id: {
        type: [String, Number],
        default: null,
      },
      label: {
        type: String,
        default: 'name',
      },
    },
    computed: {
      selected: {
        get() {
          return this.list.loaded ? this.list.data.find(el => el.id === this.id) : null;
        },
        set(el) {
          this.$emit('select', el ? el.id : null)
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .select-binding {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .title {
      font-weight: 500;
      margin: 20px 0;
      font-size: 15px;
    }

    .select {
      max-width: 280px;
      margin-right: 10px;
    }
  }
</style>